import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    bulkDelete: [],
    loading: false,
    error: null,
}

const bulkDeleteSlice = createSlice({
    name: "bulkDelete",
    initialState,
    reducers: {
        fetchBulkDeleteSuccess: (state, action) => {
            state.loading = false
            state.bulkDelete = action.payload;
        },
        fetchBulkDeleteFailure: (state, action) => {
            state.loading = false
            state.error = action.payload;
        },
    },
})

export const {
    fetchBulkDeleteSuccess,
    fetchBulkDeleteFailure,
} = bulkDeleteSlice.actions;

export default bulkDeleteSlice.reducer;